import * as types from '../actionTypes'

export const setTab = (value: string) => {
  return {
    type: types.SET_DEVELOPMENT_TAB,
    payload: value
  };
}
